<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { definePage } from "unplugin-vue-router/runtime";

definePage({
  meta: {
    title: "models.invitations.acceptInvitation",
    requiresAuth: false,
    layout: "public",
  },
});

const route = useRoute();
const router = useRouter();

onMounted(() => {
  const recipientId = "id" in route.params ? String(route.params.id) : "";
  if (!recipientId) {
    return;
  }

  void router.replace({
    name: route.query.token ? "/invite/register/[id]" : "/invite/respond/[id]",
    params: { id: recipientId },
    query: route.query,
  });
});
</script>

<template>
  <v-skeleton-loader type="article" />
</template>
